module.exports = __webpack_public_path__ + "img/icon-rueckgaberecht.cd80cee7.svg";